import { Button, Input, Select, Table } from 'antd';
import { Option } from 'antd/es/mentions';
import axios from 'axios';
import React, { useState ,useEffect } from 'react'
import { toast } from 'react-toastify';
// import "../../MainCSS.css";
import "aos/dist/aos.css";
import { GetCloseRackData, GetRackDataByStatus, GetRackDetails, SaveCloseRackData } from '../../AllAPI/ProductionAPI/ProductionApi';

const CloseRack = () => {
 const storedHeaders = JSON.parse(sessionStorage.getItem('authHeaders')) || {}
  // const storedUserData = sessionStorage.getItem('userData') || '';

  const commonHeaders = {
    headers: {
      // createdBy: storedUserData || '',
      // updatedBy: storedUserData || '',
      createdBy: 1,
      updatedBy: 2,
      userIp: storedHeaders.userIp || '',
      userLat: storedHeaders.userLat || '',
      userLong: storedHeaders.userLong || '',
      deviceSign: storedHeaders.deviceSign || '',
    },
  }

  const commonHeaders1 = {
    headers: {
      createdBy: 1,
      updatedBy: 2,
    },
  }


   const [errors, setErrors] = useState({
      rackNumber: "",
      ageing: "",
  
    });
  
    const [pageSize, setPageSize] = useState(10);
    const [filteredData, setFilteredData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalEntries, setTotalEntries] = useState(0);
  
    const [rackNumber, setRackNumber] = useState("");
    const [ageing, setAgeing] = useState("");
  
    const [allRackNumber, setAllRackNumber] = useState([]);
    const [allCloseRack, setAllCloseRack] = useState([]);
  
    //======Search data from table===============
    const handleSearch = (value) => {
      const searchValue = value.toLowerCase();
  
      const filtered = allCloseRack.filter((item) =>
        Object.values(item).some((val) =>
          String(val ?? "").toLowerCase().includes(searchValue)
        )
      );

      setFilteredData(filtered);
      setTotalEntries(filtered.length); // Update total entries count after filtering
      setCurrentPage(1);
    };
    
    //==========Pagination=======================
    const handlePageSizeChange = (value) => {
      setPageSize(value);
    };
  
   
    // ==============Get table data================
    let isCloseRackFetched = false;
    useEffect(() => {
      if (isCloseRackFetched) return;
          fetchRackMaster();
          fetchCloseRack();
      isCloseRackFetched = true;
    }, []);
  
    let isError = false;
  
    const fetchRackMaster = async () => {
      try {
        const response = await axios.get(GetRackDataByStatus, commonHeaders1);
       if (response.data === 'NOTFOUND') {
      toast.error("Data not found");
      setAllRackNumber([]); // Set to empty array to avoid map error
    } else if (Array.isArray(response.data)) {
      setAllRackNumber(response.data);
    } else {
      console.warn("Unexpected data format:", response.data);
      setAllRackNumber([]); // Fallback to prevent crash
    }
      } catch (error) {
        if (!isError) {
          console.error("Error fetching Rack Master data:", error);
          toast.error("Failed to fetch Rack Master data");
          isError = true; // Set the flag to prevent double toast
        }
      }
    };

    const fetchCloseRack = async () => {
      try {
        const response = await axios.get(GetCloseRackData, commonHeaders1);
       if (response.data && response.data.length > 0) {
          setAllCloseRack(response.data);
          setFilteredData(response.data); // Set initial filtered data as the fetched data
          setTotalEntries(response.data.length); // Set the total number of entries
        }
        else{
           toast.warn("Data not available !!");
                     setAllCloseRack([]);
                    setFilteredData([]);
                    setTotalEntries([]);
        }
      } catch (error) {
        if (!isError) {
          console.error("Error fetching Close Rack data:", error);
          toast.error("Failed to fetch Close Rack data");
          isError = true; // Set the flag to prevent double toast
        }
      }
    };

    // const columns = [
    //   {
    //     title: "Sr.No.",
    //     dataIndex: "",
    //     key: "index",
    //     render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
    //   },
    //   {
    //     title:"Rack Number",
    //     dataIndex: "rackNumber",
    //     key: "rackNumber",
    //   },
    //   {
    //     title: "Ageing Status",
    //     dataIndex: "ageingStatus",
    //     key: "ageingStatus",
    //     render: (text) => (text === 1 ? "In Process" : text === 0 ? "No" :  text === 2 ? "Completed" : "-"),
    //   },
    // ];

    const columns = [
  {
    title: "Sr.No.",
    dataIndex: "",
    key: "index",
    render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "Rack Number",
    dataIndex: "rackNumber",
    key: "rackNumber",
    sorter: (a, b) => String(a.rackNumber ?? '').localeCompare(String(b.rackNumber ?? '')),
  },
  // {
  //   title: "Ageing Status",
  //   dataIndex: "ageingDescription",
  //   key: "ageingDescription",
  //    render: (text) => text ? text : '-',
  //   sorter: (a, b) => String(a.ageingDescription ?? '').localeCompare(String(b.ageingDescription ?? '')),
  // }
  {
  title: "Ageing Status",
  dataIndex: "ageingStatus", 
  key: "ageingStatus",
  render: (status) => {
    switch (status) {
      case 1:
        return "In Process";
      case 2:
        return "NO";
      case 3:
        return "Completed";
      default:
        return "-";
    }
  },
  sorter: (a, b) => (a.ageingStatus ?? 0) - (b.ageingStatus ?? 0),
}

    ];

  
    const components = {
      header: {
        cell: ({ children, ...restProps }) => (
          <th
            {...restProps}
            style={{
              backgroundColor: "#023e7d",
              color: "#fff",
              padding: "10px",
              fontSize: "15px",
              borderRadius: "0px",
            }}
          >
            {children}
          </th>
        ),
      },
      body: {
        row: ({ children, ...restProps }) => (
          <tr
            {...restProps}
            style={{
              backgroundColor: "#f0f7fd",
            }}
          >
            {children}
          </tr>
        ),
        cell: ({ children, ...restProps }) => (
          <td
            {...restProps}
            style={{
              padding: "8px",
              fontSize:'15px'
            }}
          >
            {children}
          </td>
        ),
      },
    };

  // ========Submit data to table==============
    const handleSubmit = async () => { 
      let isValid = true;
      const errorObj = {};
  
      if (!rackNumber) {
        isValid = false;
        errorObj.rackNumber = "Rack Number is required *";
      }      
      if (!ageing) {
        isValid = false;
        errorObj.ageing = "ageing is required *";
      }
  
      setErrors(errorObj); // Set error messages
  
      if (!isValid) return;
  
      try {
        const response = await axios.put(`${SaveCloseRackData}?rackNumberId=${rackNumber}&ageingStatus=${ageing}&isFull=1`,null,commonHeaders);

        if (response.data === "RACKCLOSED") {
          toast.success("Rack Closed Successfully!");
          fetchCloseRack();
          handleCancel();
        } else if (response.data === "ALREADYEXISTED") {
          toast.warn("Rack Already Closed!");
        } else if (response.data === "NOTFOUND") {
          toast.warn("Rack Not Found!");
        }
      } catch (error) {
        console.error("Error during API call:", error);
        toast.error("Error occurred while submitting data");
      }
    };
    //==================== Handle Cancel button =====================
    const handleCancel = () => {
      setAgeing("");
      setRackNumber("");
      setErrors("");
      setRackDetails([]);
        setFilteredData1([]);
        setTotalEntries1(0);
      
    };
 
    //======================================================
    const ageingOptions = [
      { value: '1', label: 'Yes' },
      { value: '2', label: 'No' },
    ]
    //======================================================
 const columns1 = [
  {
    title: 'Sr No.',
    key: 'index',
    render: (text, record, index) => (currentPage1 - 1) * pageSize1 + index + 1,
  },
  {
    title: 'Order ID',
    dataIndex: 'orderNumber',
    key: 'orderNumber',
    sorter: (a, b) => (a.orderNumber ?? '').toString().localeCompare((b.orderNumber ?? '').toString()),
  },
  {
    title: 'Item Name',
    dataIndex: 'ItemName',
    key: 'ItemName',
    sorter: (a, b) => (a.ItemName ?? '').localeCompare(b.ItemName ?? ''),
  },
  {
    title: 'Customer Name',
    dataIndex: 'customerName',
    key: 'customerName',
    sorter: (a, b) => (a.customerName ?? '').localeCompare(b.customerName ?? ''),
  },
 

  // {
  //   title: 'Alloy',
  //   dataIndex: 'alloyName',
  //   key: 'alloyName',
  //   sorter: (a, b) => (a.alloyName ?? '').localeCompare(b.alloyName ?? ''),
  // },
  // {
  //   title: 'Temper',
  //   dataIndex: 'temperName',
  //   key: 'temperName',
  //   sorter: (a, b) => (a.temperName ?? '').localeCompare(b.temperName ?? ''),
  // },
  // {
  //   title: 'Length',
  //   dataIndex: 'length',
  //   key: 'length',
  //   align: 'right',
  //   sorter: (a, b) => (a.length ?? 0) - (b.length ?? 0),
  // },
  // {
  //   title: 'Pcs',
  //   dataIndex: 'pcs',
  //   key: 'pcs',
  //   align: 'right',
  //   sorter: (a, b) => (a.pcs ?? 0) - (b.pcs ?? 0),
  // },
  // {
  //   title: 'Weight',
  //   dataIndex: 'netWeight',
  //   key: 'netWeight',
  //   align: 'right',
  //   sorter: (a, b) => (a.netWeight ?? 0) - (b.netWeight ?? 0),
  // },
  // {
  //   title: 'Wt. Range',
  //   dataIndex: 'weightRange',
  //   key: 'weightRange',
  //   align: 'right',
  //   sorter: (a, b) => (a.weightRange ?? 0) - (b.weightRange ?? 0),
  // },

];



 
  const components1 = {
     header: {
       cell: ({ children, ...restProps }) => (
         <th
           {...restProps}
           style={{
             backgroundColor: '#000',
             color: '#fff',
             padding: '10px',
             fontSize: '15px',
             borderRadius: '0px',
           }}
         >
           {children}
         </th>
       ),
     },
     body: {
       row: ({ children, ...restProps }) => (
         <tr
           {...restProps}
           style={{
             backgroundColor: '#f0f7fd',
           }}
         >
           {children}
         </tr>
       ),
       cell: ({ children, ...restProps }) => (
         <td
           {...restProps}
           style={{
             padding: '8px',
                         fontSize: '15px',

           }}
         >
           {children}
         </td>
       ),
     },
   }
     //======Todays Dispatch Details Data Table===============
   
      const [RackDetails, setRackDetails] = useState([])
      const [filteredData1, setFilteredData1] = useState([])
      const [pageSize1, setPageSize1] = useState(10)
      const [currentPage1, setCurrentPage1] = useState(1)
      const [totalEntries1, setTotalEntries1] = useState(0)
    
    
      const handleSearch1 = (value) => {
        const searchValue = value.toLowerCase();
      
        const filtered = RackDetails.filter((item) =>
          Object.values(item).some((val) =>
            String(val ?? "").toLowerCase().includes(searchValue)
          )
        );
      
        setFilteredData1(filtered);
        setTotalEntries1(filtered.length);
        setCurrentPage1(1);
      };
      
    
      const handlePageSizeChange1 = (value) => {
        setPageSize1(value)
      }
    
      // const fetchRackDetails = async (rackNumberId)=>{
      //     try {
      //   const response = await axios.get(`${GetRackDetails}?rackNumberId=${rackNumberId}`,null, commonHeaders);
      //   if (response.data !== null) {
      //     const rack = response.data;

      // // ✅ Parse the multiline string into item objects
      // const parsedItems = rack.items
      //   .split('\n')
      //   .map(line => {
      //     const match = line.match(/ItemName:\s*(.*?),\s*Order:\s*(.*?),\s*Customer:\s*(.*)/);
      //     if (!match) return null;

      //     const [, ItemName, orderNumber, customerName] = match;

      //     return {
      //       ItemName: ItemName.trim(),
      //       orderNumber: orderNumber.trim(),
      //       customerName: customerName.trim(),
      //     };
      //   })
      //   .filter(Boolean); // Remove any lines that didn’t match

      // setRackDetails(parsedItems);
      // // setParsedRackItems(parsedItems);
      //   }
      // } catch (error) {
      //   if (!isError) {
      //     console.error("Error fetching Rack Master data:", error);
      //     toast.error("Failed to fetch Rack Master data");
      //     isError = true; // Set the flag to prevent double toast
      //   }
      // }
      // }
    const fetchRackDetails = async (rackNumberId) => {
  try {
    const response = await axios.get(
      `${GetRackDetails}?rackNumberId=${rackNumberId}`,
    
      commonHeaders
    );

    const racks = response?.data;

    // Find the rack matching the selected ID
    const rack = Array.isArray(racks)
      ? racks.find(r => r.rackNumberId === rackNumberId)
      : null;

    if (rack && typeof rack.items === 'string' && rack.items.trim() !== '') {
      const parsedItems = rack.items
        .split('\n')
        .map((line) => {
          const itemMatch = line.match(/ItemName:\s*([^,]*)/i);
          const orderMatch = line.match(/Order:\s*([^,]*)/i);
          const customerMatch = line.match(/Customer:\s*(.*)/i);

          return {
            ItemName: itemMatch?.[1]?.trim() || '-',
            orderNumber: orderMatch?.[1]?.trim() || '-',
            customerName: customerMatch?.[1]?.trim() || '-',
          };
        })
        .filter(item =>
          item.ItemName !== '-' || item.orderNumber !== '-' || item.customerName !== '-'
        );
        setRackDetails(parsedItems);
 setFilteredData1(parsedItems);
        setTotalEntries1(parsedItems.length);
        setCurrentPage1(1);
      } else {
        toast.warn("No items in the rack !!");
        setRackDetails([]);
        setFilteredData1([]);
        setTotalEntries1(0);
      }
  } catch (error) {
    if (!isError) {
      console.error('Error fetching Rack Master data:', error);
      toast.error('Failed to fetch Rack Master data');
      isError = true;
    }
    setRackDetails([]);
  }
};


  return (
 
  <div className="px-5 py-3">
   <div  className="row mt-3 p-3 py-5 mb-5 rounded" style={{backgroundColor:"#e0efff"}}>
    <div className="col-12">
     <div className="row m-0 p-0">

  {/* Centered container with side paddings */}
  <div className="col-12 col-lg-8 offset-lg-2">

    {/* Row with Rack Number and Ageing side-by-side */}
    <div className="row mb-3">
      <div className="col-12 col-lg-6">
        <label className="labels">Rack Number</label>
        <Select
          value={rackNumber || undefined}
          onChange={(value) => {
            setRackNumber(value);
            fetchRackDetails(value);
          }}
          showSearch
          className="w-100"
          placeholder="Select Rack"
          optionFilterProp="children"
        >
          {allRackNumber.map((rack) => (
            <Option key={rack.rackNumberId} value={rack.rackNumberId}>
              {rack.rackNumber}
            </Option>
          ))}
        </Select>
        {errors.rackNumber && <div className="errorField">{errors.rackNumber}</div>}
      </div>

      <div className="col-12 col-lg-6">
        <label className="labels">Ageing</label>
        <Select
          value={ageing}
          onChange={(value) => setAgeing(value)}
          showSearch
          className="w-100"
          placeholder="Select Option"
          optionFilterProp="children"
        >
          {ageingOptions.map((opt) => (
            <Option key={opt.value} value={opt.value}>
              {opt.label}
            </Option>
          ))}
        </Select>
        {errors.ageing && <div className="errorField">{errors.ageing}</div>}
      </div>
    </div>

    {/* Table and controls below */}
    <div className="row m-0 p-2 pt-md-0 mt-3">
      <div
        className="col-12 py-3 shadow border"
        style={{ marginBottom: "50px", backgroundColor: "white", overflowX: "auto" }}
      >
        <div
          className="col-12 px-lg-5"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <div>
            <span style={{ fontSize: "14px" }}>Show entries &nbsp;</span>
            <Select
              defaultValue={pageSize1}
              onChange={handlePageSizeChange1}
              style={{ width: 120 }}
            >
              <Option value={10}>10</Option>
              <Option value={20}>20</Option>
              <Option value={30}>30</Option>
            </Select>
          </div>
          <div>
            <Input.Search
              placeholder="Search"
              onChange={(e) => handleSearch1(e.target.value)}
              style={{ width: 200 }}
            />
          </div>
        </div>

        <Table
          bordered
          columns={columns1}
          dataSource={filteredData1}
          pagination={{
            pageSize: pageSize1,
            total: totalEntries1,
            showTotal: (total, range) =>
              `Showing ${range[0]} to ${range[1]} of ${total} entries`,
            current: currentPage1,
            onChange: (page) => setCurrentPage1(page),
          }}
          showSorterTooltip={true}
          rowKey={(record) => record.orderNumberId}
          components={components1}
          size="small"
          scroll={{ x: 'max-content' }}
        />
      </div>
    </div>

    {/* Buttons */}
    <div className="col-12 text-center ">
      <Button
        type="submit"
        className="CancelBtn mx-1"
        onClick={handleCancel}
      >
        Cancel
      </Button>
      <Button
        type="submit"
        className="SubmitBtn mx-1"
        onClick={handleSubmit}
      >
        Close Rack
      </Button>
    </div>

    <div className="col-12 p-0 mt-3" style={{ borderBottom: "2px solid #bfb597" }}></div>
  </div>
</div>

    
      {/*================ Table =========================*/}
      <div className="row m-0 p-2  pt-md-0 mt-3">
        <div className="col-12 py-3 shadow border" style={{ marginBottom: "50px", backgroundColor: "white" }}>
          <div className="col-12 px-lg-5" style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <span style={{ fontSize: "14px" }}>Show entries &nbsp;</span>
              <Select
                defaultValue={pageSize}
                onChange={handlePageSizeChange}
                style={{ width: 120, textAlign: "center" }}
              >
                <Option value={10}>10</Option>
                <Option value={20}>20</Option>
                <Option value={30}>30</Option>
              </Select>
            </div>
    
            <div className="pt-4 pt-lg-0">
              <Input.Search
                placeholder="Search"
                onChange={(e) => handleSearch(e.target.value)}
                style={{ width: 200, marginBottom: 16 }}
              />
            </div>
          </div>
    
          <div style={{ backgroundColor: "white" }}>
            <Table
              bordered
              style={{ padding: "0px 20px", overflowX: "auto" }}
              columns={columns}
              dataSource={filteredData}
              pagination={{
                pageSize: pageSize,
                total: totalEntries,
                showTotal: (total, range) =>
                  `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                current: currentPage,
                onChange: (page) => setCurrentPage(page),
              }}
              showSorterTooltip={false}
              rowKey={(record) => record.id}
              components={components}
            />
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
  
  )
}

export default CloseRack